/** User-facing labels for follow-ups (API routes stay `/tasks`). */

export const ACTIVITIES_PAGE_TITLE = 'Follow-ups';

export const ACTIVITIES_PAGE_SUBTITLE =
  'Customer follow-ups and internal tasks in one place.';

export const ACTIVITIES_NAV_GROUP = 'Operations';

export const ACTIVITIES_NAV_ITEM = 'Follow-ups';

export const ACTIVITIES_DASHBOARD_LABEL = 'Activity Dashboard';


export const ACTIVITIES_SEARCH_PLACEHOLDER = 'Filter by title…';

export const ACTIVITIES_NEW_BUTTON = 'Add';

export const ACTIVITIES_NEW_FOLLOWUP = 'Customer follow-up';

export const ACTIVITIES_NEW_INTERNAL = 'Internal task';

export const ACTIVITIES_NEW_RECURRING = 'Recurring task';

export const ACTIVITIES_EMPTY_DEFAULT =
  'Nothing scheduled yet. Add a follow-up to stay on top of your pipeline.';

export const ACTIVITIES_EMPTY_FILTERED = 'No follow-ups match the current filters.';

export const ACTIVITIES_PANEL_TITLE = 'Follow-ups';

export const ACTIVITIES_PANEL_EMPTY_CONTACT =
  'No follow-ups linked to this contact yet.';

export const ACTIVITIES_PANEL_EMPTY_LEAD =
  'No follow-ups linked to this lead yet.';
